import React from "react"


class Seasons extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            }
    }

    render() {
        return (
            <section>

            </section>
        )
    }

}

export default Seasons


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/Seasons.js